<app-preview></app-preview>
<router-outlet></router-outlet>
<app-link-preload [preloadList]="preloadList"></app-link-preload>
<max-loader *ngIf="maxAccountLoading"></max-loader>
